import { Compass } from 'lucide-react';

export default function PageHero({ title, subtitle }) {
  return (
    <section className="relative bg-slate-900 py-24 lg:py-36 overflow-hidden">
      {/* Background Image Layer */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20 mix-blend-luminosity"
        style={{ backgroundImage: "url('/images/minimalist-meeting-room.png')" }}
      />
      
      {/* Gradient overlay to maintain the dark slate color scheme */}
      <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/95 to-slate-900/60" />

      {/* Large Watermark Icon */}
      <div className="absolute -right-20 top-1/2 -translate-y-1/2 pointer-events-none z-0">
        <Compass 
          className="w-[500px] h-[500px] lg:w-[800px] lg:h-[800px] text-white opacity-[0.04] -rotate-12" 
          strokeWidth={0.5} 
        />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl">
          {/* Heading */}
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-[2px] bg-[#876a57]" />
            <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#876a57]">
              Ekspertise & Tillid
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1] mb-8">
            {title}
          </h1>

          {subtitle && (
            <div className="max-w-2xl">
              <p className="text-lg md:text-xl text-slate-300 leading-relaxed">
                {subtitle}
              </p>
            </div>
          )}
        </div>
      </div>
      
      {/* Visual accent line at bottom */}
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-slate-700 to-transparent z-10" />
    </section>
  );
}
